// Renova support contacts. Single source of truth is the backend
// (ClaraSystemPrompt.SUPPORT_PHONE / SUPPORT_EMAIL in checkme-backend) — keep these in sync,
// or move them into the /insurance/clara/suggestions response if this duplication bites.
export const SUPPORT_PHONE = '+525646663801';
export const SUPPORT_WHATSAPP_URL = 'https://wa.me/525646663801';
export const SUPPORT_EMAIL = 'hello@renova.world';
